"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PuzzleFactory_puzzle;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PuzzleFactory = void 0;
class PuzzleFactory {
    constructor() {
        _PuzzleFactory_puzzle.set(this, void 0);
        __classPrivateFieldSet(this, _PuzzleFactory_puzzle, {
            bits: [],
            latch: {
                block: {
                    x: 0,
                    y: 2,
                    w: 2,
                    h: 1
                }
            },
            block: {
                x: 0,
                y: 0,
                w: 6,
                h: 6
            },
            moveCount: 0
        }, "f");
    }
    addBit(block) {
        __classPrivateFieldGet(this, _PuzzleFactory_puzzle, "f").bits.push({
            id: __classPrivateFieldGet(this, _PuzzleFactory_puzzle, "f").bits.length,
            block
        });
        return this;
    }
    setLatch(block) {
        __classPrivateFieldGet(this, _PuzzleFactory_puzzle, "f").latch.block = block;
        return this;
    }
    setMoveCount(count) {
        __classPrivateFieldGet(this, _PuzzleFactory_puzzle, "f").moveCount = count;
        return this;
    }
    build() {
        return __classPrivateFieldGet(this, _PuzzleFactory_puzzle, "f");
    }
}
exports.PuzzleFactory = PuzzleFactory;
_PuzzleFactory_puzzle = new WeakMap();
